const getRawBackendUrl = (): string =>
  import.meta.env.VITE_BACKEND_URL ||
  (window as any)._env_?.BACKEND_URL ||
  'http://localhost:3000';

const stripTrailingSlash = (url: string): string => url.replace(/\/+$/, '');

export const getUtmBackendOrigin = (): string => {
  const raw = stripTrailingSlash(getRawBackendUrl());
  return raw.replace(/\/api\/v1$/i, '');
};

export const buildUtmApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getUtmBackendOrigin()}/api/v1${normalizedPath}`;
};
